module.exports = __webpack_public_path__ + "static/img/Rectangle 50.57199471.png";